<template>
  <div class="xh-sidebar">
    <el-menu
      :default-active="seleMene"
      router
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
    >
      <el-menu-item
        :index="'/' + item.id"
        v-for="item in Data.resourceType.value"
        :key="item.id"
        :route="{ name: item.id }"
      >
        <img :src="item.hoverImgUrl" alt="" class="menu-icon" v-show="seleMene == '/' + item.id" />

        <img :src="item.imgUrl" alt="" class="menu-icon" v-show="seleMene != '/' + item.id" />
        <div>{{ item.dictName }}</div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Data } from '@/stores/data'
import emitter from '@/stores/mitt'

const route = useRoute()
let seleMene = ref('/application')

let def = defineProps({
  root: {
    type: String,
    default: ''
  }
})
// import { RouteLocationNormalizedLoaded } from 'vue-router';
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

function handleSelect(key: string, keyPath: string[]) {
  console.log('选中了:', key, keyPath)
  seleMene.value = key
}
onMounted(() => {
  const pathSegments = route.path.split('/').filter((segment) => segment)

  let pathStr = ''
  // 判断路径段数是否超过2段
  if (pathSegments.length > 2) {
    // 取前两个路径段，组成新的路径
    pathStr = `/${pathSegments[0]}/${pathSegments[1]}`
  } else {
    pathStr = route.path
  }
  console.log(pathStr, '>>>>pth>>')
  seleMene.value = pathStr
  console.log(seleMene.value)
})

// 监听路由变化来重新加载数据
watch(
  () => route.path,
  () => {
    console.log(route.path)
    const pathSegments = route.path.split('/').filter((segment) => segment)
    let pathStr = ''
    // 判断路径段数是否超过2段
    if (pathSegments.length > 2) {
      // 取前两个路径段，组成新的路径
      pathStr = `/${pathSegments[0]}/${pathSegments[1]}`
    } else {
      pathStr = route.path
    }
    console.log(pathStr, '>>>>pth>>')
    seleMene.value = pathStr
    console.log(Data.isLogin.value, '>>>>login>>')
    if(!Data.isLogin.value && pathStr.includes('/knowledge')) {
      let dialogData = {
        dialogType: 'login',
        show: true,
        dialogTitle: ''
      }
      console.log(dialogData)
      emitter.emit('show-appDialog', dialogData)
    }
  }
)
</script>
<style lang="scss" scoped>
.xh-sidebar {
  background: linear-gradient(180deg, #e7eefc 0%, #eee8f6 100%);
  border-width: 0px 1px 0px 0px;
  border-style: solid;
  border-color: #f6f6fb;

  :deep(.el-menu) {
    background: transparent;
    border-right: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    //padding-top: 14px;
    .el-sub-menu.is-active .el-sub-menu__title {
      color: #837FA5 !important;
    }

    .el-menu-item.is-active {
      // 修改按钮的样式
      background: #d9e1f9;
      color: #485cec !important;
      font-weight: bold !important;
    }

    .el-menu-item:hover {
      background: #d9e1f9;
      color: #485cec !important;
      font-weight: bold !important;
    }

    .el-menu-item {
      // 修改按钮的样式
      width: 82px;
      height: auto;
      border-radius: 12px;
      margin: 20px 0 0 0;
      justify-content: center;
      display: flex;
      flex-direction: column;
      line-height: 22px;
      padding: 8px 12px;
      align-items: center;
      font-size: 14px;
      font-weight: 400 !important;
      color: #837FA5 !important;
    }
  }
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
}
</style>
